import React, {Component, createRef} from "react";
import Table from "rc-table";
import Dropdown from "rc-dropdown";
import Pagination from "rc-pagination";
import "rc-table/assets/index.css";
import "rc-dropdown/assets/index.css";
import "rc-pagination/assets/index.css";
import "../Pagination/index.css";
import "./index.css";
import faSearch from "./icons/search.svg";
import darkSearch from "./icons/darkSearch.svg";
import memoizeOne from "memoize-one";
import moment from "moment";

const defaultPagination = {
    defaultPageSize: 10,
    pageSizeOptions: ["10", "25", "50", "100", "200", "500"],
    position: "top",
};

class MenuCallback extends Component {
    state = {searchText: ""};

    setUpdateText = (target) => {
        let value = target?.value || "";
        this.setState({searchText: value});
    };

    handleSearch = () => {
        const {searchText} = this.state;
        const {confirm, searchTextName, toggleMenu} = this.props;
        confirm(searchText, searchTextName);
        toggleMenu();
    };

    handleClear = () => {
        const {handleReset, searchTextName, toggleMenu} = this.props;
        this.setState({searchText: ""}, () => {
            handleReset(searchTextName);
            toggleMenu();
        });
    };

    render() {
        const {searchText} = this.state;

        return (
            <div className="filterBtnGroup">
                <input
                    type="text"
                    placeholder="Search"
                    autoFocus
                    className="searchInput"
                    value={searchText}
                    onChange={(e) => this.setUpdateText(e.target)}
                />

                <button
                    className="btn btn-search"
                    style={{width: 90, marginRight: 8}}
                    onClick={this.handleSearch}
                >
                    <img src={faSearch} className="searchIcon" alt=""/> Search
                </button>

                <button
                    className="btn btn-reset"
                    style={{width: 90}}
                    onClick={this.handleClear}
                >
                    Reset
                </button>
            </div>
        );
    }
}

const GetColumnSearchTitleProps = (props) => {
    const {title} = props;
    const [visible, setVisible] = React.useState(false);

    const toggleMenu = () => setVisible(!visible);

    return (
        <>
            {title}

            <Dropdown
                trigger={["click"]}
                visible={visible}
                overlay={<MenuCallback {...props} toggleMenu={toggleMenu}/>}
                animation="slide-up"
                onVisibleChange={() => toggleMenu()}
            >
                <button className="searchBtn">
                    <img src={darkSearch} className="searchIcon" alt=""/>
                </button>
            </Dropdown>
        </>
    );
};

class TableMain extends Component {
    state = {
        data: [],
        columns: [],
        pagination: this.props.pagination || defaultPagination,
        loading: true,
        selectedKeys: {},
        dataSearchParams: {},
        defaultPageSize: 10,
    };

    constructor(props) {
        super(props);
        this.fetch2 = memoizeOne(this.fetch);
        this.containerRef = createRef();
    }

    componentDidMount() {
        this.setFieldsDefault();
    }

    fetch = async (params = {}) => {
        const cloneA = {...this.state.selectedKeys};

        this.setState({loading: true, dataSearchParams: params});

        params.count = params.results || this.state.pagination.defaultPageSize;

        const data = await this.props.apiRequest({...params, ...cloneA});

        const pagination = {
            ...this.state.pagination,
            total: data.total,
        };

        this.setState({
            loading: false,
            data: data.data,
            pagination,
            defaultPageSize: pagination.defaultPageSize,
        });
    };

    setLocal = () => {
        this.setState({
            loading: false,
            data: this.props.dataSource,
        });
    };

    reload = () => {
        if (this.props.apiRequest) {
            this.fetch(this.state.dataSearchParams);
        }
    };

    reloadOnPageChange = () => {
        this.setState({loading: true});

        const {pagination} = this.state;

        this.fetch({
            results: pagination.defaultPageSize,
            page: pagination.current,
        });
    };

    handleReset = (key) => {
        const cloneObj = {...this.state.selectedKeys};
        delete cloneObj[key];

        this.setState({selectedKeys: cloneObj}, () => this.fetch());
    };

    confirmFxn = (value, key) => {
        const cloneObj = {...this.state.selectedKeys};

        if (value) cloneObj[key] = [value];
        else delete cloneObj[key];

        this.setState({selectedKeys: cloneObj}, () => this.fetch());
    };

    getProcessedColumns = () => {
        const {pagination} = this.state;
        const currentPage = Number(pagination?.current) || 1;
        const pageSize = Number(pagination?.defaultPageSize) || 20;

        return (this.props.columns || []).map((i) => {
            let item = { ...i };
            if (item.searchTextName) {
                item.placeHolder = `Search ${item.title}`;

                item.title = (
                    <GetColumnSearchTitleProps
                        {...item}
                        confirm={this.confirmFxn}
                        handleReset={this.handleReset}
                    />
                );
            }

            if (
                item.dataIndex === undefined &&
                item.key !== "actions" &&
                item.type !== "actions"
            ) {
                item.dataIndex = item.key;
            }

            if (item.dataIndex === "serialNo" || item.key === "serialNo") {
                item.render = (text, record, index) => {
                    return (currentPage - 1) * pageSize + index + 1;
                };
            }

            return item;
        });
    };

    setFieldsDefault = () => {
        const {pagination = defaultPagination, apiRequest} = this.props;

        if (apiRequest) {
            this.fetch2({results: pagination.defaultPageSize});
        } else {
            this.setLocal();
        }
    };

    componentDidUpdate(prevProps) {
        if (!this.props.apiRequest && prevProps.dataSource !== this.props.dataSource) {
            this.setLocal();
        }
    }

    renderDynamic() {
        const {pagination, data} = this.state;
        const columns = this.getProcessedColumns();
        const {refence = null, extraProps = {}, showPagination = true, scroll} =
            this.props;

        return (
            <div ref={this.containerRef} className="table-container">
                <div
                    className="card-datatable table-responsive"
                    style={{minHeight: 500}}
                >
                    <Table
                        {...extraProps}
                        refence={refence}
                        bordered
                        className="table text-start align-middle table-hover mb-0 data-table"
                        columns={columns}
                        rowKey={(record) => record._id}
                        data={data}
                    />
                </div>

                {showPagination && (
                    <div className="pagination-box">
                        <Pagination
                            onChange={(item) =>
                                this.setState(
                                    {
                                        pagination: {...pagination, current: item},
                                    },
                                    () => this.reloadOnPageChange()
                                )
                            }
                            defaultPageSize={pagination.defaultPageSize}
                            pageSize={pagination.defaultPageSize}
                            current={pagination.current || 1}
                            total={pagination.total}
                        />

                        <select
                            className="page-sizer"
                            value={pagination.defaultPageSize}
                            onChange={({target}) =>
                                this.setState(
                                    {
                                        pagination: {
                                            ...pagination,
                                            defaultPageSize: target.value,
                                            current: 1,
                                        },
                                    },
                                    () => this.reloadOnPageChange()
                                )
                            }
                        >
                            {pagination.pageSizeOptions.map((item) => (
                                <option key={item} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>
        );
    }

    renderStatic() {
        const columns = this.getProcessedColumns();
        const {ref = null, extraProps = {}, dataSource, scroll} = this.props;

        return (
            <div className="card-datatable table-responsive">
                <Table
                    {...extraProps}
                    scroll={scroll}
                    refence={ref}
                    bordered
                    className="table text-start align-middle table-hover mb-0 data-table"
                    columns={columns}
                    data={dataSource}
                />
            </div>
        );
    }

    render() {
        return this.props.apiRequest
            ? this.renderDynamic()
            : this.renderStatic();
    }
}

export default TableMain;
